import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { GridCloseIcon } from '@mui/x-data-grid';
import Swal from 'sweetalert2';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import ExpenseCard from '../ExpenseCard.js/ExpenseCard';
import submitIcon from '../../../assets/promotional-expense/submit.svg';
import plusIcon from '../../../assets/promotional-expense/plus.svg';
import OpaqueLoading from '../../../components/common/opaqueLoading/opaqueLoading';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const Container = styled.div`
  width: 100%;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  margin: 20px 25px;
  width: 100%;
  height: 100%;
  align-items: stretch;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const DraftExpense = () => {
  const [expenses, setExpenses] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [eventType, setEventType] = useState();
  const [eventAmount, setEventAmount] = useState();
  const [date, setDate] = useState();
  const [eventTypeName, setEventTypeName] = useState();
  const [expenseEvents, setExpenseEvents] = useState([]);
  const [sendToClaimExpenses, setSendToClaimExpenses] = useState([]);
  const [expenseEvent, setExpenseEvent] = useState();
  const [expenseEventName, setExpenseEventName] = useState();
  const [expenseSfid, setExpenseSfid] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedExpenses, setSelectedExpenses] = useState([]);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('image', file);
      const response = await window.Platform.database.uploadFile(formData);

      if (response.hasError) {
        throw new Error('Image upload failed.');
      }

      const resultUrl = {
        fileName: file.name,
        url: response.data,
      };

      setImageUrl(resultUrl);
    } catch (error) {
      console.error('Error uploading image:', error);
      window.NotificationUtils.showError(
        error?.message || 'Failed to upload the image.'
      );
    }

    e.target.value = '';
  };

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      getEventRecordTypeId();
      getExpenseList();
    } else {
      window.location.reload();
    }
  }, []);

  const getExpenseList = async () => {
    try {
      const result = await window.Platform.database.getExpenseList({
        isDraft: true,
      });
      setExpenses(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getEventRecordTypeId = async () => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getEventRecordTypeId();
      setEventTypes(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getExpenseEventList = async (value) => {
    try {
      const payload = {
        eventType: typeof value === 'object' ? value.value : value,
        searchField: '',
        pageNumber: 1,
      };
      const result = await window.Platform.database.getExpenseEventList(
        payload
      );
      setExpenseEvents(result.data);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      eventType: eventType?.eventName,
      Formated_Event_Name__c: `${eventTypeName} (${expenseEventName})`,
      eventId: expenseEvent?.eventsfid,
      Amount__c: eventAmount,
      date__c: date,
      files__c: imageUrl?.url,
    };

    try {
      if (isEdit) {
        payload.expenseSfid = expenseSfid;
      }
      const errors = validateForm(payload);
      setErrors(errors);

      if (Object.keys(errors).length === 0) {
        const result = isEdit
          ? await window.Platform.database.updateExpenseById(payload)
          : await window.Platform.database.createExpense(payload);
        if (result.hasError) {
          window.NotificationUtils.showError(result.message);
          setLoading(false);
          throw new Error(`${isEdit ? 'Update' : 'Create'} expense failed.`);
        }

        window.NotificationUtils.showSuccess(
          `Expense has been ${isEdit ? 'updated' : 'created'} successfully`
        );
        setEventType(null);
        setEventAmount(null);
        setDate(null);
        setEventTypeName(null);
        setExpenseEvent(null);
        setImageUrl(null);
        setOpenDialog(false);
        getExpenseList();
      } else {
        window.NotificationUtils.showError('Please fill all required fields.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      window.NotificationUtils.showError(error.message);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setEventType(null);
    setEventAmount(null);
    setDate(null);
    setEventTypeName(null);
    setExpenseEvent(null);
    setImageUrl(null);
    setIsEdit(false);
  };

  const handleDialogClick = () => {
    setOpenDialog(true);
  };

  const handleEventType = (e) => {
    setEventType(e.target.value);
    setEventTypeName(e.target.value.mainEventName);
    getExpenseEventList(e.target.value.value);
  };

  const handleExpenseEvent = (e) => {
    setExpenseEvent(e.target.value);
    setExpenseEventName(e.target.value.eventname);
  };

  const handleInputChange = (e) => {
    setEventAmount(e.target.value);
  };

  const handleDateChange = (e) => {
    let formattedDate;
    if (e) {
      const dateInGmt530 = dayjs(e).utcOffset(330).format('YYYY-MM-DD');

      formattedDate = dateInGmt530;
      setDate(formattedDate);
    }
  };

  const handleExpenseUpdate = async (expense) => {
    setIsEdit(true);
    const eventType = eventTypes.find(
      (eventType) => eventType.eventName === expense.event_type__c
    );
    setEventType(eventType);
    setEventTypeName(eventType.mainEventName);
    const expenseList = await getExpenseEventList(eventType);
    const expenseEvent = expenseList.find(
      (expenseObj) => expenseObj.eventsfid === expense.eventsfid
    );
    setExpenseEvent(expenseEvent);
    setExpenseEventName(expenseEvent.expenseEventName);
    setExpenseSfid(expense.expensesfid);
    setEventAmount(expense.amount__c);
    setDate(expense.date__c ? dayjs(expense.date__c) : null);
    setImageUrl(expense.upload_file__c);
    setOpenDialog(true);
  };

  const handleExpenseDelete = async (expense) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        deleteExpense(expense);
      }
    });
  };

  const deleteExpense = async (expense) => {
    setLoading(true);
    try {
      const payload = {
        expenseSfid: expense.expensesfid,
      };

      const result = await window.Platform.database.deleteExpenseById(payload);
      if (result.hasError) throw new Error('Delete expense failed.');
      window.NotificationUtils.showSuccess(
        'Expense has been deleted successfully'
      );
      getExpenseList();
    } catch (error) {
      console.log(error.message);
      window.NotificationUtils.showError(error.message);
      setLoading(false);
    }
  };

  const handleExpenseCheck = (event) => {
    if (event.target.checked) {
      const allExpenseIds = expenses.map((e) => e.expensesfid);
      setSelectedExpenses(allExpenseIds);
      const expenseList = expenses.map((p) => {
        return {
          expenseSfid: p.expensesfid,
          herokuId: p.heroku_id__c,
        };
      });
      setSendToClaimExpenses(expenseList);
    } else {
      setSelectedExpenses([]);
      setSendToClaimExpenses([]);
    }
  };

  const handleCheck = (e, expense) => {
    if (e.target.checked) {
      setSelectedExpenses((prev) => [...prev, expense.expensesfid]);
      setSendToClaimExpenses((prev) => {
        return [
          ...prev,
          {
            expenseSfid: expense.expensesfid,
            herokuId: expense.heroku_id__c,
          },
        ];
      });
    } else {
      setSelectedExpenses((prev) =>
        prev.filter((item) => item !== expense.expensesfid)
      );
      setSendToClaimExpenses((prev) => {
        const filteredList = prev.filter(
          (item) => item.expenseSfid !== expense.expensesfid
        );
        return filteredList;
      });
    }
  };

  const handleClaimExpensesSubmit = async () => {
    setLoading(true);
    try {
      if (sendToClaimExpenses.length === 0) {
        window.NotificationUtils.showError(
          `Please select atleast an expense before submit.`
        );
        setLoading(false);
        return;
      }

      const result = await window.Platform.database.submitExpenseClaim({
        paramsData: sendToClaimExpenses,
      });
      if (result.hasError) {
        setLoading(false);
        window.NotificationUtils.showSuccess(result.message);
        throw new Error(`Expenses claim failed.`);
      }
      window.NotificationUtils.showSuccess(
        `Expenses have been claimed successfully`
      );
      getExpenseList();
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError(error.message);
    }
  };

  const validateForm = (data) => {
    const errors = {};

    const fields = ['eventType', 'eventId', 'Amount__c', 'date__c', 'files__c'];

    fields.forEach((field) => {
      if (field === 'Amount__c') {
        if (!data[field]) {
          errors[field] = `${field
            .replace(/_/g, ' ')
            .replace(/__c$/, '')} is required`;
        }
      } else {
        if (!data[field]?.trim()) {
          errors[field] = `${field
            .replace(/_/g, ' ')
            .replace(/__c$/, '')} is required`;
        }
      }
    });

    return errors;
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        height: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}

        <CustomHeader name='expense' />
        <Box p={4}>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box>
              <FormControlLabel
                control={<Checkbox onClick={handleExpenseCheck} />}
                label='Select All'
                sx={{ m: 0, mr: 2, color: '#0088CC' }}
              />
              <Button variant='outlined' onClick={handleClaimExpensesSubmit}>
                <img src={submitIcon} />
                &nbsp;&nbsp;
                <span>Submit</span>
              </Button>
            </Box>

            <Box>
              <Button variant='contained' onClick={() => handleDialogClick()}>
                <img src={plusIcon} />
                &nbsp;&nbsp;
                <span>Add New</span>
              </Button>
            </Box>
          </Box>
        </Box>

        {expenses.length > 0 ? (
          <Grid container spacing={2} padding={2} pt={0}>
            <GridContainer>
              {expenses.map((expense) => {
                return (
                  <ExpenseCard
                    key={expense.event_heroku_id__c}
                    expense={expense}
                    handleExpenseUpdate={handleExpenseUpdate}
                    handleExpenseDelete={handleExpenseDelete}
                    handleCheck={handleCheck}
                    selectedExpenses={selectedExpenses}
                    type='draft'
                  />
                );
              })}
            </GridContainer>
          </Grid>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}

        <Dialog
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '600px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event Type</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event Type'
                  value={eventType}
                  onChange={handleEventType}
                  required
                  error={Boolean(errors.eventType)}
                >
                  {eventTypes.map((item) => (
                    <MenuItem name={item.mainEventName} value={item}>
                      {item.mainEventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id='select-label'>Event ID</InputLabel>
                <Select
                  sx={{ borderRadius: '10px' }}
                  labelId='select-label'
                  label='Event ID'
                  value={expenseEvent}
                  onChange={handleExpenseEvent}
                  InputLabelProps={{
                    shrink: expenseEvent?.eventname,
                  }}
                  required
                  error={Boolean(errors.eventId)}
                >
                  {expenseEvents.map((item) => (
                    <MenuItem value={item}>
                      {eventTypeName} ({item.eventname})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                sx={{ width: '100%', borderRadius: '10px' }}
                id='field-input'
                label={`Event Amount`}
                variant='outlined'
                value={eventAmount}
                onInput={(e) => {
                  // Restrict to numbers only
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                InputLabelProps={{
                  shrink: eventAmount,
                }}
                onChange={handleInputChange}
                required
                error={Boolean(errors.Amount__c)}
                slotProps={{
                  textField: {
                    sx: {
                      borderRadius: '10px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                      },
                    },
                  },
                }}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ width: '100%' }}>
                  <DatePicker
                    label='Date'
                    value={date ? dayjs(date) : null}
                    onChange={handleDateChange}
                    format='YYYY-MM-DD'
                    required
                    minDate={dayjs().add(1, 'day')}
                    error={Boolean(errors.date__c)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: Boolean(errors.date__c),
                        sx: {
                          width: '100%',
                          borderRadius: '10px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        },
                      },
                    }}
                  />
                </Box>
              </LocalizationProvider>

              <div style={{ width: '100%' }}>
                <Box
                  sx={{
                    width: '100%',
                    '&:hover': {
                      cursor: 'pointer',
                    },
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: errors.files__c
                        ? '1px solid red'
                        : '1px solid #B9B9B9',
                      borderRadius: '10px',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <Box
                      onClick={handleIconClick}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        gap: 2,
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '5px 10px',
                      }}
                    >
                      <Typography sx={{ color: '#B9B9B9' }}>Upload</Typography>
                      <IconButton color='primary'>
                        <img
                          src={plusIcon}
                          alt='File Upload'
                          width={20}
                          height={20}
                        />
                      </IconButton>
                    </Box>
                  </div>

                  <input
                    type='file'
                    accept='image/*,.pdf'
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    required
                  />
                </Box>

                <Box sx={{ mt: 1 }}>
                  {imageUrl && !errors.files__c && (
                    <Typography variant='body2' color='textSecondary'>
                      File uploaded to AWS server.
                    </Typography>
                  )}
                </Box>
              </div>

              <FlexContainer
                style={{ justifyContent: 'center', width: '100%', gap: 30 }}
              >
                <Button variant='outlined' onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant='contained' onClick={handleSubmit}>
                  {isEdit ? 'Update' : 'Save'}
                </Button>
              </FlexContainer>
            </DialogContainer>
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );
};

export default DraftExpense;
